import { render, staticRenderFns } from "./SignInWrapper.vue?vue&type=template&id=5a1e8029&scoped=true"
import script from "./SignInWrapper.vue?vue&type=script&lang=ts"
export * from "./SignInWrapper.vue?vue&type=script&lang=ts"
import style0 from "./SignInWrapper.vue?vue&type=style&index=0&id=5a1e8029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e8029",
  null
  
)

export default component.exports